import { AIModelKind } from 'shared/entities/smartbotAI';
import {
  AIModelPricingRowKind,
  AITariffication,
  AITarifficationServer,
  normalizeAITariffication,
  orderAIModelPricingRows
} from 'shared/entities/tariffication';

type PricingBreakdownRow = {
  row: AIModelPricingRowKind;
  prices: { base: number; second?: number };
};

export class AITarifficationModel {
  private readonly tariffication: AITariffication;

  constructor({ tariffication }: { tariffication: AITariffication }) {
    this.tariffication = tariffication;
  }

  getDisplayPrice = (modelKind: AIModelKind): number | null => {
    return (
      this.getShortRowPrices(modelKind, AIModelPricingRowKind.input)?.base ??
      null
    );
  };

  getShortRowPrices = (
    modelKind: AIModelKind,
    row: AIModelPricingRowKind
  ): { base: number; second?: number } | null => {
    const pricing = this.tariffication?.[modelKind];

    if (!pricing) {
      return null;
    }

    return pricing[row] ?? null;
  };

  getPricingBreakdownRows = (modelKind: AIModelKind): PricingBreakdownRow[] => {
    const pricing = this.tariffication?.[modelKind];

    if (!pricing) {
      return [];
    }

    return orderAIModelPricingRows.reduce((acc, row) => {
      const prices = pricing[row];

      if (prices) {
        acc.push({ row, prices });
      }

      return acc;
    }, [] as PricingBreakdownRow[]);
  };

  static fromJson(raw: AITarifficationServer) {
    return new AITarifficationModel({
      tariffication: normalizeAITariffication(raw)
    });
  }
}
